'use strict';
angular.module('ringbaPortal')
  .directive('trSignup', function() {
    return {
      restrict: 'E',
      scope: {},
      controller: 'SignupController',
      controllerAs: 'vm',
      bindToController: true,
      templateUrl: '/scripts/components/auth/signup.view.html'
    };
  })
;
